(ns hai.tasks.urgency-menu
  "The menu an urgency is picked from: a heading, None above a rule from the
   lanes, and the pick checked."
  (:require
   [hai.tasks.urgency :as urgency]
   [hai.ui.components :as c]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

;; On the class Radix's content element is handed: the heading in small caps,
;; and the pick marked by a check on the right — Radix keeps its own on the
;; left, in the gutter every item then carries, so the gutter goes and the
;; indicator moves.
(o/defstyled menu-content :div
  {"--base-menu-item-padding-left" "12px"
   "--base-menu-item-padding-right" "36px"}
  [:.rt-BaseMenuLabel
   {:text-transform "uppercase"
    :letter-spacing "0.06em"
    :font-size "11px"
    :font-weight "700"
    :color t/--card-forest-70}]
  [:.rt-BaseMenuItemIndicator
   {:left "auto" :right "0" :width "36px"}]
  ;; Radix's highlight (pointer or keyboard) takes over while it holds; the
  ;; pick shows as a faint forest wash inside a hairline the rest of the time.
  [".rt-BaseMenuRadioItem[data-state='checked']:not([data-highlighted])"
   {:background t/--card-forest-06
    :outline-width "1px" :outline-style "solid"
    :outline-color t/--card-forest-14 :outline-offset "-1px"}])

(defn- items
  [{:keys [value on-change]}]
  [c/DropdownMenuRadioGroup
   {:value (name (or value urgency/none))
    :onValueChange #(on-change (keyword "task.urgency" %))}
   [c/DropdownMenuRadioItem {:value (name urgency/none)}
    (urgency/label urgency/none)]
   [c/DropdownMenuSeparator]
   (for [{lane-value :value :keys [label]} urgency/lanes]
     ^{:key lane-value}
     [c/DropdownMenuRadioItem {:value (name lane-value)}
      label])])

(defn component
  "`trigger` opens the menu on `value`; `on-change` gets the picked urgency.
   `container` is the element the menu portals into, when a host has one."
  [{:keys [heading align container] :as props} trigger]
  ;; Radix hands focus back to the trigger as the menu closes, and inside the
  ;; sidebar's injected frame the browser paints a focus ring on it — after a
  ;; click, which is the case `:focus-visible` exists to suppress and doesn't
  ;; here. So make that call ourselves: a menu opened by pointer skips the
  ;; restore, one opened by keyboard keeps it, since that is the one that needs
  ;; somewhere to return to.
  (r/with-let [pointer-opened? (atom false)]
    ;; Non-modal, as [[hai.ui.components.dropdown-menu]] is: a modal menu locks
    ;; body scroll, which in the sidebar means locking the page it is injected
    ;; into. Its touch guard comes along for the same reason — the trigger opens
    ;; on pointerdown, and the focus shift that follows reads as an outside
    ;; interaction to a non-modal dismiss layer, closing the menu as it opens.
    [c/DropdownMenuRoot {:modal false}
     [c/DropdownMenuTrigger
      {:onPointerDown (fn [_] (reset! pointer-opened? true))
       :onKeyDown (fn [_] (reset! pointer-opened? false))}
      trigger]
     [c/DropdownMenuContent
      (cond-> {:align align
               :class (str menu-content)
               :onFocusOutside (fn [^js e] (.preventDefault e))
               :onCloseAutoFocus (fn [^js e]
                                   (when @pointer-opened?
                                     (.preventDefault e)))}
        container (assoc :container container))
      [c/DropdownMenuLabel heading]
      [items props]]]))
